<template>
  <div
    class="plugin-row-card"
    :style="{ width: $vw(width) }"
  >
    <via-plugin-icon
      class="plugin-icon"
      :icon="icon"
      :icon-color="iconColor"
      :icon-bg-color="iconBgColor"
      :size="50"
    />
    <div class="plugin-right">
      <div class="plugin-name">
        {{ name }}
      </div>
      <div class="plugin-author">
        {{ author | cutFont(17) }}
      </div>
      <div class="plugin-update-time">
        更新：{{ updateTime | timeFormat(1) }}
      </div>
    </div>
    <van-button
      class="plugin-link-btn"
      type="primary"
      @click="goToPluginDetail(pluginId)"
    >查看</van-button>
  </div>
</template>

<script>
import ViaPluginIcon from 'components/common/via-plugin-icon'
import { Button } from 'vant'
import { timeFormat, cutFont } from '~/utils/filters'

export default {
  name: 'ViaPluginRowCard',
  filters: {
    timeFormat,
    cutFont
  },
  components: {
    [ViaPluginIcon.name]: ViaPluginIcon,
    [Button.name]: Button
  },
  props: {
    // rpx
    width: {
      type: Number,
      default: 375
    },
    pluginId: {
      type: Number,
      default: null
    },
    icon: {
      type: String,
      default: ''
    },
    iconColor: {
      type: String,
      default: 'var(--light100)'
    },
    iconBgColor: {
      type: String,
      default: 'var(--light40)'
    },
    name: {
      type: String,
      default: ''
    },
    author: {
      type: String,
      default: ''
    },
    updateTime: {
      type: Number,
      default() {
        return new Date().getTime()
      }
    }
  },
  methods: {
    goToPluginDetail(id) {
      this.$router.$push({
        name: 'PluginDetail',
        params: { id }
      })
    }
  }
}
</script>

<style scoped>
.plugin-row-card {
  position: relative;
  display: flex;
  align-items: center;
  height: 80px;
  background-color: var(--light100);
  box-sizing: border-box;
}
.plugin-icon-box {
  margin-left: 15px;
}
.plugin-right {
  position: relative;
  max-width: 200px;
  height: 100%;
  margin-left: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.plugin-name {
  font-size: 14px;
  font-weight: 900;
}
.plugin-author {
  font-size: 12px;
  color: var(--light50);
  margin: 4px 0;
}
.plugin-update-time {
  font-size: 12px;
  color: var(--light50);
}
.plugin-link-btn {
  width: 60px;
  height: 30px;
  border-radius: 15px;
  position: absolute;
  top: 25px;
  right: 15px;
  line-height: 30px;
  font-size: 12px;
}
</style>
